import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { toast } from 'react-toastify';
import { CommonReligiousCultsCrumbs } from 'civil-status/constants/place';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import FormPlace from 'civil-status/components/place/form';
import { PlaceForm } from 'civil-status/view-models/place';
import { transformRequest } from 'civil-status/utils/place';
import { DomainType } from 'civil-status/constants/domain';

const ReligiousCultsNewPage = (): React.ReactElement => {
  const insertReligiousCults = useHttpClient(`${__ACT_API_URL__}/valori-dominio-atti/insert`, {
    options: {
      method: 'POST',
      loading: true,
      errorCatching: true,
    },
  });

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues?: PlaceForm) => {
      const data = transformRequest(formValues, DomainType.ReligiousCults);

      (
        insertReligiousCults({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/culti-religiosi');
      });
    },
    [insertReligiousCults, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonReligiousCultsCrumbs, { name: 'Nuovo culto religioso' }]} />
      <FormPlace title="Inserimento culto religioso" onSave={onSubmit} isReligiousCults />
    </Fragment>
  );
};

ReligiousCultsNewPage.displayName = 'Religious Cults new page component';

export default ReligiousCultsNewPage;
